import { DollarOutlined, FallOutlined, FileTextOutlined, RiseOutlined, UserAddOutlined } from '@ant-design/icons';
import { Row } from 'antd';
import React from 'react';
import { useHttpQuery } from '@esg/framework';
import { agencyApis } from '@esg/business-agency';
import { KPICard } from '../../../../Components';
// import {apiFetch} from '@my-monorepo/utils'

const KpiCardContainer: React.FC = () => {
    const kpiData = [
        {
            title: 'Current MRR',
            value: 245500000,
            change: 12.5,
            suffix: ' ₫',
            prefix: <DollarOutlined style={{ color: '#13C2C2' }} />,
        },
        {
            title: 'Active Contracts',
            value: 142,
            change: 8.3,
            prefix: <FileTextOutlined style={{ color: '#13C2C2' }} />,
        },
        {
            title: 'New Customers',
            value: 18,
            change: 15.4,
            prefix: <UserAddOutlined style={{ color: '#13C2C2' }} />,
        },
        {
            title: 'Win Rate',
            value: 68,
            change: 5.2,
            suffix: '%',
            prefix: <RiseOutlined style={{ color: '#13C2C2' }} />,
        },
        {
            title: 'Churn Rate',
            value: 4.2,
            change: -1.1,
            suffix: '%',
            prefix: <FallOutlined style={{ color: '#FF4D4F' }} />,
        },
    ];

    const { data: branchSubscriptions } = useHttpQuery(
        agencyApis.subscription.getAllBranchSubscription
    );

    console.log(branchSubscriptions);

    return (
        <Row gutter={[16, 16]}>
            {kpiData.map((item) => (
                <KPICard
                    title={item.title}
                    value={item.value}
                    change={item.change}
                    suffix={item.suffix}
                    prefix={item.prefix}
                />
            ))}
        </Row>
    );
};

export { KpiCardContainer };
